(() => {
  const enabled = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let active = null;
  let frame = 0;
  let point = null;
  const reset = () => {
    cancelAnimationFrame(frame);
    frame = 0;
    if (!active) return;
    active.classList.remove('np-tilting');
    active.style.removeProperty('--np-tilt-x');
    active.style.removeProperty('--np-tilt-y');
    active = null;
  };
  const render = () => {
    frame = 0;
    if (!active?.isConnected || !enabled.matches) return reset();
    const bounds = active.querySelector('.card__inner').getBoundingClientRect();
    if (!bounds.width || !bounds.height) return reset();
    const clamp = value => Math.max(-1, Math.min(1, value));
    const x = clamp((point.x - bounds.left) / bounds.width * 2 - 1);
    const y = clamp((point.y - bounds.top) / bounds.height * 2 - 1);
    active.style.setProperty('--np-tilt-x', `${(-y * 12).toFixed(2)}deg`);
    active.style.setProperty('--np-tilt-y', `${(x * 12).toFixed(2)}deg`);
    active.classList.add('np-tilting');
  };
  // Delegation also covers cards replaced by XCloud filtering and pagination.
  document.addEventListener('pointermove', event => {
    if (!enabled.matches || event.pointerType === 'touch') return reset();
    const card = event.target instanceof Element ? event.target.closest('.product-card-wrapper') : null;
    if (!card?.querySelector('.card__inner .card__media')) return reset();
    if (active !== card) { reset(); active = card; }
    point = { x: event.clientX, y: event.clientY };
    if (!frame) frame = requestAnimationFrame(render);
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    if (active && (!(event.relatedTarget instanceof Node) || !active.contains(event.relatedTarget))) reset();
  }, { passive: true });
  window.addEventListener('blur', reset);
  window.addEventListener('scroll', reset, { passive: true });
  document.addEventListener('visibilitychange', reset);
  enabled.addEventListener('change', reset);
})();
